var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Checkbox, Collapse, IconButton, Typography } from '@mui/material';
var CollapseOptionsGroup = function (params) {
    var _a = __read(useState(true), 2), open = _a[0], setOpen = _a[1];
    var checkedState = params.allSubGroupSelected(params.group);
    return (React.createElement("div", null,
        React.createElement("div", { className: "lfc-flex lfc-justify-between lfc-items-center lfc-bg-gray-200" },
            React.createElement("div", { className: "lfc-flex lfc-items-center" },
                React.createElement(Checkbox, { checked: checkedState.all, indeterminate: checkedState.indeterminate, onChange: function () {
                        params.handleSubSelectAll(params.group);
                    } }),
                React.createElement(Typography, { variant: "body1" }, params.group)),
            React.createElement(IconButton, { onClick: function () {
                    setOpen(!open);
                } }, open ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null))),
        React.createElement(Collapse, { in: open }, params.children)));
};
export default CollapseOptionsGroup;
//# sourceMappingURL=CollapseOptionsGroup.js.map